import React, { useEffect } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import bg from '../../../assets/realestate.jpg'
import residentialImg from '../../../assets/realestate5.jpg';
import commercialImg from '../../../assets/realestate2.jpg';
import infrastructureImg from '../../../assets/realestate3.jpg';
import customImg from '../../../assets/realestate4.jpg';

const Realestate = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <div>
      <section className="hero-section" style={{ backgroundImage: `url(${bg})`, backgroundSize: 'cover', height: '500px', color: 'white' }}>
        <Container className="d-flex align-items-center h-100">
          <Row className="w-100">
            <Col className="text-center" data-aos="fade-up">
              <h1>Welcome to SHIVEK REALSTATE AND TECHNOLOGY</h1>
              <p>Your Trusted Partner in Real Estate and Construction</p>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="about py-5">
        <Container data-aos="fade-up">
          <Row>
            <Col md={12}>
              <h2 className="text-center">At SHIVEK REALSTATE AND TECHNOLOGY</h2>
              <p className="text-center">
                We specialize in providing high-quality construction solutions for all your real estate needs. With years of experience, we pride ourselves on delivering exceptional projects across various sectors, ensuring excellence, efficiency, and
                reliability every step of the way.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="services py-5 bg-light">
        <Container>
          <h2 className="text-center mb-4" data-aos="fade-up">Our Services</h2>
          <Row>
            <Col md={3} className="service-card" data-aos="fade-right">
              <div className="service-img" style={{ backgroundImage: `url(${residentialImg})`, backgroundSize: 'cover', height: '200px' }}></div>
              <h3>Residential Construction</h3>
              <p>From houses and flats to luxurious penthouses,
              we design and build homes that cater to your lifestyle and needs.</p>
            </Col>

            <Col md={3} className="service-card" data-aos="fade-up">
              <div className="service-img" style={{ backgroundImage: `url(${commercialImg})`, backgroundSize: 'cover', height: '200px' }}></div>
              <h3>Commercial Projects</h3>
              <p>Whether you need a warehouse, office space, or
commercial building, we create functional, modern, and cost-effective
commercial structures.</p>
            </Col>

            <Col md={3} className="service-card" data-aos="fade-left">
              <div className="service-img" style={{ backgroundImage: `url(${infrastructureImg})`, backgroundSize: 'cover', height: '200px' }}></div>
              <h3>Railway Projects</h3>
              <p>We specialize in railway infrastructure services, offering railway contracts, bridge construction, railway line repairs, and station development.</p>
            </Col>

            <Col md={3} className="service-card" data-aos="fade-right">
              <div className="service-img" style={{ backgroundImage: `url(${customImg})`, backgroundSize: 'cover', height: '200px' }}></div>
              <h3>Custom Solutions</h3>
              <p>Whatever the scale or complexity of your project, our
              expert team will bring your unique vision to life.</p>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="why-choose py-5">
        <Container data-aos="fade-up">
          <h2 className="text-center mb-4">Why Choose SHIVEK REALSTATE AND TECHNOLOGY?</h2>
          <Row>
            <Col md={3}>
              <h4>Affordable Pricing</h4>
              <p>We offer cost-effective solutions without compromising quality.</p>
            </Col>
            <Col md={3}>
              <h4>Quality Workmanship</h4>
              <p>Built with high-quality materials and expert craftsmanship.</p>
            </Col>
            <Col md={3}>
              <h4>Experienced Team</h4>
              <p>Our team of architects and engineers ensures flawless execution.</p>
            </Col>
            <Col md={3}>
              <h4>Timely Delivery</h4>
              <p>We complete projects on time without sacrificing quality.</p>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="contact py-5 bg-light">
        <Container>
          <h2 className="text-center mb-4" data-aos="fade-up">Get in Touch</h2>
          <Row>
            <Col md={6}>
              <p>If you have any questions or want to discuss your project, feel free to contact us!</p>
              <ul style={{listStyle:'none'}}>
                <li>Email: shiveke@gmail.com</li>
                <li>Phone: 9424809020 </li>
              </ul>
            </Col>
            <Col md={6}>
                <Link to="/contact">
                  <Button variant="primary" size="lg">Contact Us Now</Button>
                </Link>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Realestate;
